<div fxLayout="column" fxFill fxLayoutAlign="start stretch">
  <div class="consent-text">
    We log user interactions on our tool for analytics to improve your experience. By clicking “Accept” you agree to the use of logs.
    <br/>
    Personal information such as username will not be logged.
  </div>
  <div fxLayout="row" fxLayoutAlign="end center">
    <button mat-raised-button class="consent-accept-btn" color="primary" (click)="setUserConsent(true)">Accept</button>
    <button mat-raised-button class="consent-reject-btn" (click)="setUserConsent(false)">Reject</button>
  </div>
</div>